import DomPurify from "isomorphic-dompurify";
import { ChevronDown } from "lucide-react";
import { useEffect, useId, useRef } from "react";
type FaqDisplayItemProps = {
  section: {
    question: string;
    answer: string;
  };
  defaultExpanded?: boolean;
};

const FaqDisplayItem = ({ section, defaultExpanded }: FaqDisplayItemProps) => {
  const id = useId();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current && defaultExpanded !== undefined) {
      inputRef.current.checked = defaultExpanded;
    }
  }, [defaultExpanded]);

  return (
    <div>
      <div className="lex relative flex flex-col border-b border-primary-300" id="faqdisplay-59">
        <label htmlFor={id} className="cursor-pointer py-5 pr-5 text-lg font-semibold text-primary-700">
          {section.question}
        </label>
        <input ref={inputRef} type="checkbox" className="peer/qa hidden appearance-none" id={id} tabIndex={0} />
        <ChevronDown className="absolute right-0 top-5 peer-checked/qa:rotate-180" />
        <div className="hidden peer-checked/qa:block">
          <p
            className="whitespace-pre-wrap pb-8 text-md"
            dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(section.answer) }}
          />
        </div>
      </div>
    </div>
  );
};

export default FaqDisplayItem;
